var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.downloadLoading,
          expression: "downloadLoading",
        },
      ],
      staticClass: "task-config-container",
    },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入第三方订单号", clearable: "" },
                    model: {
                      value: _vm.searchForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orderNo", $$v)
                      },
                      expression: "searchForm.orderNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入外部订单号", clearable: "" },
                    model: {
                      value: _vm.searchForm.thirdPartyNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "thirdPartyNo", $$v)
                      },
                      expression: "searchForm.thirdPartyNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "输入优惠券", clearable: "" },
                    model: {
                      value: _vm.searchForm.couponName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "couponName", $$v)
                      },
                      expression: "searchForm.couponName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: { placeholder: "券模板ID", clearable: "" },
                    model: {
                      value: _vm.searchForm.couponId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "couponId", $$v)
                      },
                      expression: "searchForm.couponId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "180px" },
                    attrs: { placeholder: "商品名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "productName", $$v)
                      },
                      expression: "searchForm.productName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "核销状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.verifyStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "verifyStatus", $$v)
                        },
                        expression: "searchForm.verifyStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "已核销", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "未核销", value: "0" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "发放状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "发放中", value: "0" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已发放", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "发放失败", value: "2" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已作废", value: "3" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "核销开始日期",
                      "end-placeholder": "核销结束日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.searchForm.timeRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "timeRange", $$v)
                      },
                      expression: "searchForm.timeRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.download } },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                border: "",
                "element-loading-text": "数据加载中...",
                "element-loading-spinner": "el-icon-loading",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderOrginalNo",
                  label: "第三方订单号",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "thirdPartyNo",
                  label: "外部订单号",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "手机号", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cardNo", label: "卡号", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponName",
                  label: "优惠券名称",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "couponId", label: "优惠券ID", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "商品名称",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "发放状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 0
                          ? _c("div", [_vm._v("发放中")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c("div", [_vm._v("已发放")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 2
                          ? _c("div", [_vm._v("发放失败")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 3
                          ? _c("div", [_vm._v("已作废")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "原价", prop: "oprice", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "B端结算价", prop: "bprice", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "C端销售价", prop: "cprice", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "是否反核销",
                  prop: "isRefunded",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isRefunded == 0
                          ? _c("span", [_vm._v("否")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.isRefunded == 1
                          ? _c("span", [_vm._v("是")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "反核销时间", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.refundTime
                          ? _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("parseTime")(
                                      scope.row.refundTime,
                                      "{y}-{m}-{d} {h}:{i}"
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "核销状态",
                  prop: "verifyStatus",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.verifyStatus == "0"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("未核销"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.verifyStatus == "1"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("已核销"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "核销时间",
                  prop: "orderTime",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "核销订单号",
                  prop: "orderNo",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "核销门店",
                  prop: "orderStore",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "兑换时间", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.createTime
                          ? _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("parseTime")(
                                      scope.row.createTime,
                                      "{y}-{m}-{d} {h}:{i}"
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  fixed: "right",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.verifyStatus == 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openCouponLogDialog(scope.row)
                                  },
                                },
                              },
                              [_vm._v("修改券码")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "user-dialog",
          attrs: {
            title: "",
            "close-on-click-modal": true,
            visible: _vm.showUserDialog,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUserDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.couponList, border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "编号",
                  width: "60",
                  align: "center",
                  index: _vm.indexMethod,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponName",
                  label: "优惠券名称",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "couponId", label: "优惠券ID", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "发放状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 0
                          ? _c("div", [_vm._v("发放中")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c("div", [_vm._v("已发放")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 2
                          ? _c("div", [_vm._v("发放失败")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 3
                          ? _c("div", [_vm._v("已作废")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "下单时间",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "核销单号", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyStatus",
                  label: "核销状态",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.verifyStatus == "0"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("未核销"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.verifyStatus == "1"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("已核销"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { float: "right", "margin-top": "20px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm2.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm2.limit,
                  total: _vm.searchForm2.total,
                },
                on: {
                  "current-change": _vm.handlePageChange2,
                  "size-change": _vm.handleSizeChange2,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改券码",
            visible: _vm.showCouponLogDialog,
            width: "400px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCouponLogDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c("el-form-item", { attrs: { label: "原券码" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.couponLogForm.originalCouponNo || "-")),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "新券码" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入新的券码", clearable: "" },
                    model: {
                      value: _vm.couponLogForm.couponNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.couponLogForm, "couponNo", $$v)
                      },
                      expression: "couponLogForm.couponNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCouponLogDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitCouponLog },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }